import React from 'react'
import filter from 'lodash/filter'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import MdCheck from 'react-icons/lib/md/check'
import MdAccessTime from 'react-icons/lib/md/access-time'
import MdCheckCircle from 'react-icons/lib/md/check-circle'
import MdRemoveCircle from 'react-icons/lib/md/remove-circle'
import MdInfo from 'react-icons/lib/md/info'

export default function(signersStatus, feaSigners, biosSigners, faceStatus) {
    
    // console.log("====SignersStatus===");
    // console.log("====>> signersStatus", signersStatus);
    // console.log("====>> faceStatus", faceStatus);

    const firmasAplicadas = filter(signersStatus, signerStatus => signerStatus.didSign).length
    const feaAplicadas = filter(feaSigners, feaSigner => feaSigner.didSign).length
    if(!biosSigners)
      biosSigners=[]
    const biosAplicadas = filter(biosSigners, biosSigner => biosSigner.didSign).length
    const faceAplicadas = filter(faceStatus, faceStatus => faceStatus.didSign).length
    /*
    console.log("FeaSigners", feaSigners);
    feaSigners.forEach(feaSigner => {
      console.log("feaSigner", feaSigner);
      if(feaSigner.signData){
        console.log("Hay signdata");
        feaAplicadas++;
      } else {
        console.log("NO Hay signdata");
      }  
    });
    */
  /*
    console.log("signersStatus", signersStatus);
    console.log("firmasAplicadas", firmasAplicadas);
    console.log("feasAplicadas", feaAplicadas);
    console.log("biosAplicadas", biosAplicadas);
    console.log("faceAplicadas", faceStatus);
    */  
  let dataSign = []
  let dataFea = []
  let dataBio = []
  let dataFace = []
  let countDoSign = 0

  const totalSigner = (typeSigner, data) => {
    typeSigner.forEach(user => {
      const search = data.findIndex(email => user.email === email.email)
      if(search === -1){
        data.push({email: user.email, total: 1, signed: user.didSign? 1: 0})
      } else {
        data[search] = {email: user.email, total: data[search].total + 1, signed: user.didSign? data[search].signed + 1 : dataSign[search].signed }
      }
    })
  }
  
  totalSigner(signersStatus,dataSign)
  totalSigner(feaSigners,dataFea)
  totalSigner(biosSigners,dataBio)
  totalSigner(faceStatus,dataFace)

  const totalSign = (data) => {
    data.map((signerStatus) => {
          if(signerStatus.total === signerStatus.signed) countDoSign += 1
    })
  }

  totalSign(dataSign)
  totalSign(dataFea)
  totalSign(dataBio)
  totalSign(dataFace)

    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <Tooltip content={renderTooltipContent(signersStatus, feaSigners, biosSigners, faceStatus)}>
              {renderTooltip(firmasAplicadas, signersStatus, feaSigners, feaAplicadas, biosSigners, biosAplicadas, faceStatus, faceAplicadas)}
            </Tooltip>
          </div>
          <div className="col-xs-12 col-sm-8">
            <span>
              {countDoSign} de {dataSign.length + dataFea.length + dataBio.length + dataFace.length}
            </span>
          </div>
        </div>
      </div>
    )
}

function renderTooltip(pendingSigns, signersStatus, feaSigners, feaAplicadas, biosSigners, biosAplicadas, faceStatus, faceAplicadas) {
    let total = signersStatus.length + feaSigners.length + biosSigners.length + faceStatus.length
    let totalAplicadas = feaAplicadas + pendingSigns + biosAplicadas + faceAplicadas
    if ( total === 0 ) {
      return <MdRemoveCircle size={17} style={{color: '#e4ac00'}} />
    }
    if (totalAplicadas === total) {
      return <MdCheckCircle size={17} style={{color: '#3CB371'}} />
    }
    return <MdInfo size={17} />
}

function renderTooltipContent(signersStatus, feaSigners, bioSigners, faceStatus) {
  let total = signersStatus.length + feaSigners.length + bioSigners.length + faceStatus.length
    if (total === 0) {
      return <p> Documento sin firmantes</p>
    }
    return(
      <div>
        Firmas Simples:
        {renderSigners(signersStatus)}
        {renderBioFirmas(bioSigners)}
        Firmas Avanzadas:
        {renderSigners(feaSigners)}
        
      </div>
      
    )
}
//Firmas Faciales: {renderSigners(faceStatus)}

function renderBioFirmas(bioSigners){
  if(bioSigners && bioSigners.length > 0){
    return(
      <div>
        Autorizaciones Biométricas
        {renderSigners(bioSigners)}
      </div>
    )
  }
}

function renderSigners(signers){
  if(signers.length>0){
    let data = []
    signers.forEach(user => {
      const search = data.findIndex(email => user.email === email.email)
      if(search === -1){
        data.push({email: user.email, total: 1, signed: user.didSign? 1: 0})
      } else {
        data[search] = {email: user.email, total: data[search].total + 1, signed: user.didSign? data[search].signed + 1 : data[search].signed }
      }
    });
    return data.map((signerStatus, key) => {
      return (
        <p key={key}>
          {signerStatus.total === signerStatus.signed && <MdCheck style={{color: 'green', marginRight: 5}} />}
          {signerStatus.total !== signerStatus.signed && <MdAccessTime style={{color: 'gray', marginRight: 5}} />}
          {signerStatus.email}
        </p>
      )
    })
  } else {
    return ( <p>&nbsp;- Sin firmantes</p> )
  }
}


// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Common/SignersStatus.js